// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const TAB_PRECO_TP_PRECIFIC = {
  PrecoFixo: 'TAB_PRECO_TP_PRECIFIC1',
  MargemBruta: 'TAB_PRECO_TP_PRECIFIC2',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    TAB_PRECO_TP_PRECIFIC1: 1,
    TAB_PRECO_TP_PRECIFIC2: 2
  }
}
